module.exports = __webpack_public_path__ + "img/toshiko-takaezu.6ab0dcfa.png";